<script>
	import { login, centerInfo } from '@/api/user.js'
	import { storeToRefs } from 'pinia'
	import useStoreFun from '@/stores/index.js';
	
	import { wxType } from '@/config/index.js'
	import { getTemplateId } from '@/api/college.js'
	// #ifdef MP-WEIXIN
	const livePlayer = requirePlugin('live-player-plugin');
	// #endif
	export default {
		onLaunch: function() {
			console.log('App Launch')
			// 获取太壹院模板id
			getTemplateId().then(res => {
				// tyPageId.value = wxType == 0 ? res.data : '355';
				if(res.code == 200) {
					tyPageId.value = res.data;
				}else{
					tyPageId.value = wxType == 0 ? '346' : '355';
				}
			})
			const { useUserStore } = useStoreFun()
			const { userInfo, tyPageId } = storeToRefs(useUserStore)
			
			
			const query = uni.getLaunchOptionsSync().query;
			if (query.openId && query.unionId) {
				login({
					...query,
					loginMode: 'wechatH5Login'
				}).then(res => {
					if (res.data.code == '000000') {
						uni.setStorageSync('bingo-token', res.data.saTokenInfo.tokenValue)
						uni.setStorageSync('openId', query.openId);
						centerInfo().then(res4 => {
							userInfo.value = res4.data
						})
					} else if (res.data.code == '000011') { // 绑定手机号
						uni.navigateTo({
							url: `${res.data.pagePath}?openId=${query.openId}&unionId=${query.unionId}`
						})
					}
				})
			}
		},
		onShow: function(options) {
			console.log('App Show')
			// #ifdef MP-WEIXIN
			// 分享卡片/订阅消息/扫码二维码/广告/朋友圈等场景才能调用getShareParams接口获取以下参数
			const sceneList = [1007, 1008, 1014, 1044, 1045, 1046, 1047, 1048, 1049, 1073, 1154, 1155]
			if (sceneList.includes(options.scene)) {
				livePlayer.getShareParams().then(res => {
					console.log(res)
					console.log(JSON.stringify(res.custom_params))
					// this.$request({
					// 	url: '/broadcast/liveShare',
					// 	method: 'post',
					// 	data: {
					// 		roomId: res.room_id,
					// 		openId: res.openid,
					// 		shareOpenId: res.share_openid,
					// 		customParams: JSON.stringify(res.custom_params)
					// 	}
					// });
				}).catch(err => {
					console.log(err)
				});
			}
			
			// 版本更新
			const updateManager = uni.getUpdateManager();
			updateManager.onCheckForUpdate(function(res) {
				// console.log(res)
				if (res.hasUpdate) {
					updateManager.onUpdateReady(function(res) {
						uni.showModal({
							showCancel: false,
							title: '更新提示',
							content: '新版本已经准备好，是否重启应用？',
							success(res) {
								if (res.confirm) {
									updateManager.applyUpdate();
								}
							}
						});
					});
				}
			});
			// #endif
		},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style lang="scss">
@import url('@/static/css/flex.css');
@font-face {
	font-family: iconfont;
	src: url('@/static/iconfont/iconfont.ttf');
}
@font-face {
	font-family: MyFontNumber;
	src: url('https://oss.bgbgsc.com/bingo-file/static/otf/number.otf');
}
.page { min-height: 100vh; background: #f5f5f5;}
.mb-20{
	margin-bottom: 20rpx;
}
.mt-20{
	margin-top: 20rpx;
}
.labels {
	margin-top: 12rpx;
	.tag {
		margin-right: 8rpx;
		line-height: 30rpx;
		font-size: 24rpx;
		border-radius: 8rpx;
		padding: 0 6rpx;
	}
}
</style>
